// extracted by mini-css-extract-plugin
module.exports = {"hotkey":"Functions_hotkey__uCahM","badgeText":"Functions_badgeText__1HEMR","badge":"Functions_badge__2btsZ","iconButton":"Functions_iconButton__3KLIU"};